import PropTypes from "prop-types"
import { Avatar, ListItemAvatar, ListItem, ListItemText } from "@mui/material"
import { ErrorOutline } from "@mui/icons-material"
import { appendTimestamp } from "modules/server-notifications/helpers"

export default function Error({ error, createdAt }) {
  return <ListItem>
    <ListItemAvatar>
      <Avatar className="error">
        <ErrorOutline />
      </Avatar>
    </ListItemAvatar>
    <ListItemText primary={error} secondary={appendTimestamp("Security Search Results", createdAt)} />
  </ListItem>
}

Error.propTypes = {
  error: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
}
